import { render, staticRenderFns } from "./commodityManagementPrice.vue?vue&type=template&id=7d6f72c6&scoped=true&"
import script from "./commodityManagementPrice.vue?vue&type=script&lang=js&"
export * from "./commodityManagementPrice.vue?vue&type=script&lang=js&"
import style0 from "./commodityManagementPrice.vue?vue&type=style&index=0&id=7d6f72c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6f72c6",
  null
  
)

export default component.exports